import React, { useState, useEffect, useRef, useCallback } from 'react'
import Grid from '@material-ui/core/Grid';
import ImputComponent from "./../../InputComponent"
import { LanguageFactory } from '../../../factories';
import { useLanguage } from '../../../store/languageContext'
import SearchDebounceBar from '../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Card, message, Table } from 'antd';
import { LocalPersistence } from "../../../factories/index";
import { sessionType } from '../../../interfaces/index'
import { getRecreations } from './../../../services/recreation';
import Loading from '../../Loading';
import './TabpanelDetail.css'
import { sortHelper } from '../../../helpers/misc/sortHelper'
import { paginationSize, getPaginationSession } from '@helpers/misc/setPaginationSize'

interface propsTypes {
    addAndEdit: () => any,
    detailAndedit: (param?: any) => any
}
const TabpanelDetail = (props: propsTypes) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [dataSource, setDataSource] = useState([]);
    const [addLoading, setAddLoading] = useState(false)

    const total = dataSource.length
    const [searchs, setSearch] = useState<string[]>([])
    const [data, setData] = useState(dataSource);
    const [paginationData, setPaginationData] = useState<number>(10)

    const columns = [
        {
            title: '',
            key: 'index',
            // @ts-expect-error
            render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
            width: '40px'
        },
        {
            title: lang.translate(language, 'Amenities_name'),
            dataIndex: 'name',
            key: 'name',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Amenities_type'),
            dataIndex: 'type',
            key: 'type',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
            showSorterTooltip: false
        },
        {
            title: 'Recreation ID',
            dataIndex: 'id',
            key: 'recreationid',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'recreationid'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Amenities_proximity'),
            dataIndex: 'proximity',
            key: 'proximity',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'proximity'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Amenities_typeDetail'),
            dataIndex: 'typedetail',
            key: 'typedetail',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'typedetail'),
            showSorterTooltip: false
        }
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                itemData[col['dataIndex']] = (item[col.dataIndex] && item[col.dataIndex].toString().toLowerCase()) || '';
            })
            return JSON.stringify(Object.values(item))
                .toLocaleLowerCase()
                .indexOf(query.toLocaleLowerCase()) > -1;

        })
        filterData.forEach((item: any, index: any) => { item.key = '' + index; })
        setDataSource(filterData);
    }

    const getPaginationData = useCallback(async () => {
        return await getPaginationSession(
            setPaginationData,
            'recreation'
        );
    }, [])

    //init data
    useEffect(() => {
        const postingData = async () => {
            setAddLoading(true)
            const get_session = new LocalPersistence('session')
            const session: sessionType = await get_session.getSessionPersistence()
            await getPaginationData();
            getRecreations(session.supplier, session.propertyId).then((res) => {
                if (res.result.success) {
                    const resData = res && res.property && res.property.recreations && res.property.recreations.length > 0 ? res.property.recreations : [];
                    resData.forEach((item: any, index: number) => { item.key = '' + index; })
                    setDataSource(resData);
                    setData(resData)
                    setAddLoading(false)
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
            }, err => {
                message.error({
                    content: err.message || err.error[0].message
                });
                setAddLoading(false)
            })
        }
        postingData();

    }, [])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (
        addLoading ? <Loading type="large" /> : <Card>
            <Grid container spacing={0} className="containerSpacing py-0">
                <Grid item xs={12} className="p-0">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ fontWeight: 'bold' }}> Recreation</div>
                        <div><Button style={{ background: `rgb(0, 71, 113)`, color: `rgb(255, 255, 255)`, width: '60px', height: '28px' }} onClick={() => { props.addAndEdit() }}>Add</Button></div>
                    </div>
                </Grid>
                <Grid item xs={4} className="pb-0 px-0 my-0">
                    <ImputComponent
                        className='SearchBar'
                        label='Search'
                        labelShrink={true}
                        value={searchTerm}
                        onChange={onChangeSearch}
                        placeholder='Search Recreation'
                        endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                    />
                    <div className="recentlySearchs">
                        <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                    </div>
                </Grid>
                <Grid item xs={12} className="p-0">
                    <Table
                        columns={columns}
                        dataSource={dataSource}
                        pagination={{
                            size: "small",
                            total,
                            showSizeChanger: true,
                            showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                            defaultPageSize: paginationData,
                            defaultCurrent: 1,
                            onShowSizeChange: (current, size: number) => paginationSize('pagination', { 'recreation': size })
                        }}
                        onRow={(record:any) => {
                            return {
                                onClick: event => {
                                    let _record = record
                                    if(!_record.schedule || _record.schedule.length === 0){
                                        let operationtime = [
                                            {dayoftheweek: "Mon", starttime: null, endtime: null},
                                            {dayoftheweek: "Tue", starttime: null, endtime: null},
                                            {dayoftheweek: "Wed", starttime: null, endtime: null},
                                            {dayoftheweek: "Thu", starttime: null, endtime: null},
                                            {dayoftheweek: "Fri", starttime: null, endtime: null},
                                            {dayoftheweek: "Sat", starttime: null, endtime: null},
                                            {dayoftheweek: "Sun", starttime: null, endtime: null}
                                        ]
                                        _record.schedule = [
                                            {
                                                operationtime,
                                                charge:[{type:''}]
                                            }
                                        ]
                                    }
                                    if(!_record.details || _record.details.length === 0){
                                        _record.details = [{}]
                                    }
                                    props.detailAndedit(_record)
                                }, // 点击行

                            };
                        }}

                    />
                </Grid>
            </Grid>

        </Card>

    )
}

export default TabpanelDetail;

